module.exports = __webpack_public_path__ + "static/media/audio-playing-animation.22b1a5c3.gif";